module.exports = __webpack_public_path__ + "static/media/childimpact.09a28ef8.svg";